/* eslint-disable react/no-string-refs */
import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Button from "components/CustomButtons/Button.js";
import brandTheme from "brandTheme/Theme";
import ToastModal from "views/components/ToastModal";
//import FileUploadIcon from "@material-ui/icons/FileUpload";
//import UploadFileIcon from "@material-ui/icons/UploadFile";
//import UploadIcon from "@material-ui/icons/Upload";
const styles = {
  fileUpload: {
    display: "flex",
  },
  upload:{
    boxShadow:'inherit',
    color:brandTheme.white,
    margin:"0 5px 0 0 ",
    height:"40px",
    // width:"8%",
    padding:'0px 40px',
    backgroundColor:brandTheme.buttonColor,
    '&:hover':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    },
    '&:focus':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    }
  }
};

class FileUploadDisbursal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      imagePreviewUrl: this.props.avatar || "",
      previewUrl: this.props.avatar || "",
       toast: false,
      toastMessageType: "",
      toastMessage: "",
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.toastUpdate = this.toastUpdate.bind(this);
  }
  handleImageChange(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      // Max 1 MB size is allowed to upload
      if (file.size > 5000000) {
        this.toastUpdate("Error", "Selected file size is more than 5 MB. Please select file with size less than 5 MB.", true)
      } else if (
        this.props.supportedMimeType &&
        this.props.supportedMimeType.indexOf(file.type) === -1
      ) {
        this.toastUpdate("Error", "Selected file is not supported.\n Supported File Type are " +
          this.props.supportedMimeType.toString(), true)
      }else {
        this.setState(
          {
            file: file,
            imagePreviewUrl: file.name,
            previewUrl: reader.result,
          },
          () => this.props.sendFile(file)
        );
      }
    };
    reader.readAsDataURL(file);
  }
  handleSubmit(e) {
    e.preventDefault();
    // this.state.file is the file/image uploaded
    // in this function you can save the image (this.state.file) on form submit
    // you have to call it yourself
  }
  handleClick() {
    this.refs.fileInput.click();
  }
  handleRemove() {
    this.setState({
      file: null,
      imagePreviewUrl: this.props.avatar || "",
      previewUrl: this.props.avatar || "",
    });
    this.refs.fileInput.value = null;
    if (this.props.removeFile) {
      this.props.removeFile();
    }
  }
  toastUpdate(type, message, showToast) {
    this.setState({
      toast: showToast,
      toastMessage: message,
      toastMessageType: type,
    });
  }
  render() {
    var {
      avatar,
      addButtonProps,
      changeButtonProps,
      removeButtonProps,
    } = this.props;
    return (
      <>
        <div className="fileinput fileUpload text-left" style={{position:"relative"}}>
          <input
            type="file"
            onChange={this.handleImageChange}
            ref="fileInput"
            style={{ opacity: 0,
              position: "absolute",
              left: 0,
              top: "20px", 
              zIndex:-1,
            }}
          />
          <div>
            {/* {this.state.previewUrl && (
              <img
                src={this.state.previewUrl}
                className="picture-src"
                width="80%"
                height="200px"
                alt="..."
              />
            )} */}
            {/* <p>{this.state.imagePreviewUrl}</p> */}
          </div>
          <div>
            {this.state.file === null ? (
              <Button onClick={() => this.handleClick()} className={this.props.classes.upload}>
                {/* <span>
                  <UploadFileIcon />
                </span> */}
                <span>{avatar ? "BROWSE" : "Upload"}</span>
              </Button>
            ) : (
              <span className="fileUpload">
                <Button
                  {...changeButtonProps}
                  style={{ display: "inline" }}
                  onClick={() => this.handleClick()}
                >
                  Change
                </Button>
                {avatar ? <br /> : null}
                <Button
                  {...removeButtonProps}
                  style={{ display: "inline" }}
                  onClick={() => this.handleRemove()}
                >
                  <i className="fas fa-times" /> Remove
                </Button>
              </span>
            )}
          </div>
        </div>
        {this.state.toast && (
          <ToastModal
            toastMessage={this.state.toastMessage}
            toastMessageType={this.state.toastMessageType}
            toastUpdate={this.toastUpdate}
          />
        )}
      </>
    );
  }
}

FileUploadDisbursal.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
  supportedMimeType: PropTypes.array,
  sendFile: PropTypes.any,
};

export default withStyles(styles)(FileUploadDisbursal);
